import React from 'react'
import { nanoid } from 'nanoid'

import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  FormHelperText,
} from '@material-ui/core'

import { useTheme } from '@material-ui/core/styles'

const SelectField = (props) => {
  const theme = useTheme()

  if (props?.data?.length > 1 || props.disableAutoselect) {
    return (
      <>
        <FormControl variant="outlined" color="primary" fullWidth>
          <InputLabel
            error={props.error}
            label="teste"
            shrink
            id={`input-label-${nanoid()}`}
          >
            {props.label}
          </InputLabel>
          <Select
            id={`select-label-${nanoid()}`}
            label={props.label}
            labelId={`input-label-${props.label}`}
            name={props.name}
            inputRef={props.inputRef}
            displayEmpty
            value={props.value ? props.value : ''}
            defaultValue={props.defaultValue ? props.defaultValue : ''}
            onChange={props.onChange}
            input={<OutlinedInput notched label={props.label} />}
            error={props.error}
            disabled={props?.disabled}
          >
            <MenuItem value="" disabled key={nanoid()}>
              <span style={{ color: theme.palette.text.secondary }}>
                {props.placeholder}
              </span>
            </MenuItem>
            {props?.data?.map((el) => {
              if (el._id !== props.hideItem) {
                return (
                  <MenuItem value={el._id} key={nanoid()}>
                    {el.name}
                  </MenuItem>
                )
              }
              return null
            })}
          </Select>
          {props.helperText && (
            <FormHelperText style={{ color: theme.palette.error.main }}>
              {props.helperText}
            </FormHelperText>
          )}
        </FormControl>
      </>
    )
  } else if (props?.data?.length === 1) {
    return (
      <>
        <FormControl variant="outlined" color="primary" fullWidth>
          <InputLabel
            error={props.error}
            label="teste"
            shrink
            id={`input-label-${nanoid()}`}
          >
            {props.label}
          </InputLabel>
          <Select
            id={`select-label-${nanoid()}`}
            label={props.label}
            labelId={`input-label-${props.label}`}
            name={props.name}
            inputRef={props.inputRef}
            displayEmpty
            value={props.value ? props.value : props?.data?.[0]._id}
            defaultValue={
              props.defaultValue ? props.defaultValue : props?.data?.[0]._id
            }
            onChange={props.onChange}
            input={<OutlinedInput notched label={props.label} />}
            error={props.error}
            disabled={props?.disabled}
          >
            {/* <MenuItem value="" key={nanoid()}>
              <span style={{ color: theme.palette.text.secondary }}>
                {props.placeholder}
              </span>
            </MenuItem> */}
            <MenuItem value={props?.data?.[0]._id} key={nanoid()} selected>
              {props?.data?.[0].name}
            </MenuItem>
          </Select>
          {props.helperText && (
            <FormHelperText style={{ color: theme.palette.error.main }}>
              {props.helperText}
            </FormHelperText>
          )}
        </FormControl>
      </>
    )
  } else {
    return (
      <>
        <FormControl variant="outlined" color="primary" fullWidth>
          <InputLabel
            error={props.error}
            label="teste"
            shrink
            id={`input-label-${nanoid()}`}
          >
            {props.label}
          </InputLabel>
          <Select
            id={`select-label-${nanoid()}`}
            label={props.label}
            labelId={`input-label-${props.label}`}
            name={props.name}
            inputRef={props.inputRef}
            displayEmpty
            value={props.value ? props.value : ''}
            defaultValue={props.defaultValue ? props.defaultValue : ''}
            onChange={props.onChange}
            input={<OutlinedInput notched label={props.label} />}
            error={props.error}
            disabled={props?.disabled}
          >
            <MenuItem value="" disabled key={nanoid()}>
              <span style={{ color: theme.palette.text.secondary }}>
                {props.placeholder}
              </span>
            </MenuItem>
          </Select>
          {props.helperText && (
            <FormHelperText style={{ color: theme.palette.error.main }}>
              {props.helperText}
            </FormHelperText>
          )}
        </FormControl>
      </>
    )
  }
}

export default SelectField
